import React, { useState } from "react";
import "./commonresultbox.css";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import BookmarkIcon from "@material-ui/icons/Bookmark";
import DeleteOutlineOutlinedIcon from "@material-ui/icons/DeleteOutlineOutlined";
import BookmarkBorderOutlinedIcon from "@material-ui/icons/BookmarkBorderOutlined";
import ReportIcon from "@material-ui/icons/Report";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { IconButton } from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";

// import { Editor } from "react-draft-wysiwyg";
// import { EditorState } from 'draft-js';
// import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

// let contentState=resultText;
// let editorState = EditorState.createWithContent(contentState);
// const [readOnly, setReadOnly] = useState("false");
// const [re]
// const [editorStateVal, setEditorState] = useState(editorState);

// const onEditorStateChangeFunc = (editorState) => {

//   setEditorState(editorState)
// }

// return (
//   <div className="captionsresultbox">
/* <Editor
  editorState={editorStateVal}
  toolbarClassName="toolbarClassName"
  wrapperClassName="wrapperClassName"
  editorClassName="editorClassName"
  onEditorStateChange={onEditorStateChangeFunc}
/>; */

function CaptionResultbox({ resultText, onDelete, index, onSave, arrData, bookmarkArray, setBookmarkArray, isCurrentBookMark }) {
  const [readOnly, setReadOnly] = useState("false");
  const [resultBoxText, setResultBoxText] = useState(resultText);
  const [currentBookmark, setCurrentBookmark] = useState(isCurrentBookMark);

  const handleBookmark = () => {
    let tempArr = bookmarkArray;
    tempArr[index] = !currentBookmark;
    setCurrentBookmark(!currentBookmark);
    setBookmarkArray(tempArr);
  }
  return (
    <div className="captionsresultbox">
      <div
        onInput={(e) => {
          setResultBoxText(e.target.innerText);
        }}
        contentEditable={readOnly}
        className="captionsresultbox__textbox"
      >
        {resultText}
      </div>
      <div className="resultbox__content__footer">
        {/* <div className="resultbox__content__characters">
          {" "}
          <span className="resultbox_content_select"> Content</span>
          <span className="resultbox_content__length">
            250 characters/20 words
          </span>
        </div> */}
        <hr></hr>
        <div className="resultbox_content_icons">
          <div className="resultbox_content_icons_left">
            <Tooltip title="Copy">
              <IconButton
                onClick={(e) => {
                  e.preventDefault();
                  navigator.clipboard.writeText(resultBoxText);
                }}
              >
                <i className="material-icons custom resultbox_content_icon">
                  content_copy
                </i>
              </IconButton>
            </Tooltip>
            <Tooltip title="Edit">
              <IconButton
                onClick={(e) => {
                  e.preventDefault();
                  readOnly === "true"
                    ? setReadOnly("false")
                    : setReadOnly("true");
                }}
              >
                <EditOutlinedIcon className="resultbox_content_icon" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Plagiarism Check">
              <IconButton>
                <ReportIcon className="resultbox_content_icon" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Delete">
              <IconButton
                onClick={(e) => {
                  e.preventDefault();
                  onDelete(index);
                }}
              >
                <DeleteOutlineOutlinedIcon className="resultbox_content_icon" />
              </IconButton>
            </Tooltip>
            {/* <Tooltip title="Save">
              <IconButton
                onClick={(e) => {
                  e.preventDefault();
                  let newResultText = arrData;
                  newResultText.text = `output: ${resultBoxText}`;
                  onSave(index, newResultText);
                }}
              >
                <CheckCircleIcon className="resultbox_content_icon" />
              </IconButton>
            </Tooltip> */}
          </div>
          <Tooltip title="Bookmark">
            <IconButton onClick={handleBookmark}>
              {currentBookmark ? <BookmarkIcon className="resultbox_content_icon" /> : <BookmarkBorderOutlinedIcon className="header_icons" />}
            </IconButton>
          </Tooltip>
        </div>
      </div>
    </div>
  );
}

export default CaptionResultbox;
